const en={
    name:'successfully'
}
export default en;